const SmartContextErrorLevel = {
  ERROR: 'ERROR',
  WARNING: 'WARNING',
};

const SmartContextErrorTypes = {
  AC_NOT_ENABLED: {
    level: SmartContextErrorLevel.WARNING,
  },
  AI_FRIEND_ENABLED: {
    level: SmartContextErrorLevel.WARNING,
  },
  SHOULD_NOT_GENERATE_SMART_CONTEXT_RESPONSE: {
    level: SmartContextErrorLevel.WARNING,
  },
  USER_DOES_NOT_EXIST: {
    level: SmartContextErrorLevel.ERROR,
  },
  USER_DATA_DOES_NOT_EXIST: {
    level: SmartContextErrorLevel.ERROR,
  },
  COACH_DOES_NOT_EXIST: {
    level: SmartContextErrorLevel.ERROR,
  },
  COACH_DATA_DOES_NOT_EXIST: {
    level: SmartContextErrorLevel.ERROR,
  },
  CHAT_CHANNEL_DOES_NOT_EXIST: {
    level: SmartContextErrorLevel.ERROR,
  },
  OPENAI_REFUSED_TO_GENERATE_RESPONSE: {
    level: SmartContextErrorLevel.ERROR,
  },
  OPENAI_RETURNED_INVALID_RESPONSE: {
    level: SmartContextErrorLevel.ERROR,
  },
};

export { SmartContextErrorTypes, SmartContextErrorLevel };
